// eslint-disable-next-line import/prefer-default-export
export const PayCalendarProfileTabs = {
  GENERAL: { index: 0, label: 'general' },
  CONFIGURATION: { index: 1, label: 'configuration' },
  PAY_CYCLES: { index: 2, label: 'payCycles' },
  EMPLOYEES: { index: 3, label: 'employees' },
  DEDUCTION_REPORTS: { index: 4, label: 'deductionReports' },
};
